module.exports = __webpack_public_path__ + "static/media/send_to_wms_icon_disabled.9564791e.svg";